// extracted by mini-css-extract-plugin
export var errorsContainer = "_ue-1";
export var link = "_ue-0";